var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.distance)?_c('div',{staticClass:"last-updated"},[_c('i',{staticClass:"material-icons"},[_vm._v("")]),_c('p',[_vm._v(_vm._s(_vm.$t({ path: 'overview.last_updated', args: { distance: _vm.distance } })))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }